import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { dateRangeFilterOptions, strCode } from "../../../consts";
import { t } from "../../../services";
import { dateUtil } from "../../../utils";

import { Button, DateRangeInput, FlexContainers, RadioGroup } from "../../../components";
import {
  FilterDropdownOptionsList,
  ButtonsWrapper,
  DateRangeInputWrapper,
  GridRadioGroupWrapper
} from "./styled";
import { selectPeriod, selectDatesRange } from "../../../state/selectors";
import { getState } from "../../../state/store";

const DateRangeFiltersDropdownOptions = ({ visible, options, filterOption, onApply, onCancel }) => {
  const [selectedFilterOption, setSelectedFilterOption] = useState(filterOption);

  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [rangeInputFrom, setRangeInputFrom] = useState();
  const [rangeInputTo, setRangeInputTo] = useState();

  const period = selectPeriod()(getState());

  useEffect(() => {
    if (period === dateRangeFilterOptions.RANGE) {
      const dates = selectDatesRange()(getState());

      if (dates?.from && dates?.to) {
        setRangeInputFrom(dates?.from);
        setRangeInputTo(dates?.to);

        onApply(period, dates?.from, dates?.to);
      }
    }
  }, []);

  useEffect(() => {
    setSelectedFilterOption(filterOption);
  }, [filterOption, visible]);

  useEffect(() => {
    const { fromDate, toDate } = dateUtil.calculateRange(selectedFilterOption);

    setFrom(fromDate);
    setTo(toDate);
  }, [selectedFilterOption]);

  useEffect(() => {
    if (selectedFilterOption === dateRangeFilterOptions.RANGE) {
      setFrom(rangeInputFrom);
      setTo(rangeInputTo);
    }
  }, [selectedFilterOption, rangeInputFrom, rangeInputTo]);

  const today = new Date();

  return (
    <FilterDropdownOptionsList
      visible={visible}
      isDateRange={selectedFilterOption === dateRangeFilterOptions.RANGE}>
      <GridRadioGroupWrapper width="100%">
        <RadioGroup
          name="date-ranges"
          options={options}
          selectedId={selectedFilterOption}
          onChange={setSelectedFilterOption}
        />
      </GridRadioGroupWrapper>

      {selectedFilterOption === dateRangeFilterOptions.RANGE && (
        <DateRangeInputWrapper Container={FlexContainers.FlexRowEnd} width="100%" mt={8}>
          <DateRangeInput
            fromDate={rangeInputFrom}
            fromTitle={strCode.FROM_TITLE}
            setFromDate={setRangeInputFrom}
            toDate={rangeInputTo}
            toTitle={strCode.TO_TITLE}
            setToDate={setRangeInputTo}
            minDate={new Date(today.getFullYear() - 5, today.getMonth(), today.getDate())}
            maxDate={today}
            disabled={selectedFilterOption !== dateRangeFilterOptions.RANGE}
          />
        </DateRangeInputWrapper>
      )}

      <ButtonsWrapper Container={FlexContainers.FlexRowEnd} width="100%" gap={12} mt={24}>
        <Button secondary onClick={() => onCancel()}>
          {t(strCode.CANCEL_BTN)}
        </Button>

        <Button disabled={!from || !to} onClick={() => onApply(selectedFilterOption, from, to)}>
          {t(strCode.APPLY_BTN)}
        </Button>
      </ButtonsWrapper>
    </FilterDropdownOptionsList>
  );
};

DateRangeFiltersDropdownOptions.propTypes = {
  visible: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  filterOption: PropTypes.string,
  onApply: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default DateRangeFiltersDropdownOptions;
